import Button from 'modules/Core/sub-modules/ui-kit/components/Button';
import { useIsOpen } from 'modules/Core/hooks/useIsOpen';
import styles from "./styles.module.scss";
import ScheduleTimeForm from '../ScheduleTimeForm';

const ScheduleTimeButton = ({ boothId, text = "+", id, initialState }) => {
    const { open, close, isOpen } = useIsOpen();
    return (
        <>
            <Button className={styles.button} onClick={open}>
                {text}
            </Button>
            <ScheduleTimeForm
                id={id}
                boothId={boothId}
                isOpen={isOpen}
                close={close}
                initialState={initialState}
            />
        </>
    )
}

export default ScheduleTimeButton;